<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex mb-4 xs12>
          <h1>Transfer Code</h1>
          <h1>양도받기 코드</h1>
          Send this ({{full_transfer_code.length}}) character code to your ticket seller.  
          <br/>
          Code expires in 24 hours
          <br/>
          아래 ({{full_transfer_code.length}})자리 코드를 
          <br/>양도 하시는 분에게 보내주세요.
          <br/>코드 24시간후에 바꿔요
      </v-flex>
      <v-flex mb-4 xs12 text-xs-center>
          <div class='event_profile_code' my-4>
              {{full_transfer_code}}
          </div>
      </v-flex>
      <v-flex mt-4 xs12>
          <v-btn :to="`/events/${event.id}`">OK</v-btn>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';

export default {
  data: () => ({event: {}, full_transfer_code: '--'}),
  beforeMount: async function() {
    await this.$store.dispatch('loadEvents');
    await this.$store.dispatch('loadAttendees');
    this.show_event();
    this.determine_full_transfer_code();
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees']),
  },
  watch: {
    events(to, from) {
      this.show_event();
    },
    attendees(to, from) {
      this.determine_full_transfer_code();
    },
  },
  methods: {
    show_event() {
      this.$data.event = this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
    determine_full_transfer_code() {
      let at = this.attendees?.find(x => {
        return x.event_id == this.$route.params.event_id;
      });
      this.$data.full_transfer_code = at?.full_transfer_code;
    },
  },
};
</script>

<style>
.event_profile_code {
  font-size: 3em;
  padding: 1em;
  border: 0px solid black;
}
</style>
